import React, { useEffect, useState } from "react";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import Select from "react-select";
// Chatbot assets (reusing existing folder)
import Chatbot from "./components/chatbot/Chatbot";
import SchoolRating from "./components/SchoolRating";
import NoIndexSEO from "../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../utils/seoConfig";
// import './components/chatbot/Chatbot.scss';
// Removed expand icon; using a close button instead
import { ReactComponent as CommingSoonIcon } from "../../assets/images/comming-soon.svg";
import { activityEnd, activityStart } from "../../redux/slices/trackActivitySlice";
import { useDispatch } from "react-redux";
import usePageTracking from "../../hooks/usePageTracking";

const Relocation = () => {

  const dispatch = useDispatch();
  // Track Activity 
usePageTracking("RELOCATION");

  useEffect(() => {
    const payload = {
      page_name: "RELOCATION",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "RELOCATION",
        }),
      );
    };
  }, [dispatch]);

  

  const [filters, setFilters] = useState({
    costOfLiving: "",
    lifestyle: "",
    housing: "",
    hospitalType: "",
    importantFactors: [],
  });

  // ---- specialty options for react-select ----
  const specialtyOptions = [
    { value: "cardiology", label: "Cardiology" },
    { value: "orthopedics", label: "Orthopedics" },
    { value: "pediatrics", label: "Pediatrics" },
    { value: "surgery", label: "Surgery" },
  ];

  // state for react-select
  const [selectedSpecialty, setSelectedSpecialty] = useState(null);

  // ---- all results ----
  const allResults = [
    {
      city: "Houston, TX",
      salary: "$95,000",
      cost: "15% lower",
      hospital: "Mayo Clinic, Abbott Northwestern",
      schools: "Average",
      crime: "Average",
    },
    {
      city: "Minneapolis, MN",
      salary: "$92,500",
      cost: "10% lower",
      hospital: "Mayo Clinic, Abbott Northwestern",
      schools: "Lower",
      crime: "Lower",
    },
    {
      city: "Raleigh, NC",
      salary: "$89,000",
      cost: "20% lower",
      hospital: "Duke University Hospital, UNC Health",
      schools: "Average",
      crime: "Average",
    },
  ];

  const [results, setResults] = useState(allResults);

  const handleSelect = (group, value, multi = false) => {
    if (multi) {
      setFilters((prev) => {
        const exists = prev[group].includes(value);
        return {
          ...prev,
          [group]: exists
            ? prev[group].filter((v) => v !== value)
            : [...prev[group], value],
        };
      });
    } else {
      setFilters((prev) => ({ ...prev, [group]: value }));
    }
  };

  const handleSearch = () => {
    setResults(allResults);
  };

  const renderOptions = (group, options, multi = false) =>
    options.map((opt) => (
      <div
        key={opt}
        className={`col-md-4 ${group === "housing" ? "col-md-6" : ""} 
                ${multi ? "checkbox-option" : "radio-option"} 
                ${multi
            ? filters[group].includes(opt)
              ? "selected"
              : ""
            : filters[group] === opt
              ? "selected"
              : ""
          }`}
        onClick={() => handleSelect(group, opt, multi)}
      >
        <div className="contentwrap">
          <input
            type={multi ? "checkbox" : "radio"}
            checked={
              multi ? filters[group].includes(opt) : filters[group] === opt
            }
            readOnly
          />
          <label className={` ${multi ? "checkbox-label" : "radio-label"} `}>
            <span className="circle"></span>
            {opt}
          </label>
        </div>
      </div>
    ));

  // Chatbot now handled via Chatbot component

  return (
    // <div className="relocation-content">
    //     <NoIndexSEO title={seoConfig.relocation.title} />
    //     <div className="app-page-title">
    //         <div className="page-title-heading">
    //             <h3 className="page-title">Relocation</h3>
    //         </div>
    //     </div>

    //     <Card>
    //         <Card.Body>
    //             <div className="header-banner">
    //                 <h3>Relocation Helper – Find The Best City For <br />Your Career & Family</h3>
    //                 <p>
    //                     Enter your details to discover the best U.S. cities and hospitals for
    //                     your career, <br />adjusted for cost of living, schools, and safety.
    //                 </p>
    //             </div>

    //             {/* Chat Helper Section (separate, minimal) */}
    //             <div className="chat-now-section text-center">
    //                 <h5><strong>Hi, I'm your Relocation Helper Assistant.</strong></h5>
    //                 <p>Tell me your salary, specialty, or lifestyle preferences, and I'll suggest the best cities & hospitals for you.</p>
    //                 <span
    //                     className="chat-now-link"
    //                     onClick={() => window.dispatchEvent(new Event('open-relocation-chatbot'))}
    //                 >
    //                     Chat now
    //                 </span>
    //             </div>

    //             <div className="card-container">
    //                 <Card className="">
    //                     <Row className="salary-specialty-row">
    //                         <Col md={6}>
    //                             <Form.Group className="form-group">
    //                                 <label className="col-label">Current Salary</label>
    //                                 <input
    //                                     type="number"
    //                                     className="col-input"
    //                                     placeholder="$85,000"
    //                                 />
    //                             </Form.Group>
    //                         </Col>
    //                         <Col md={6}>
    //                             <Form.Group className="form-group">
    //                                 <label className="col-label">Specialty</label>
    //                                 {/*  React Select Dropdown */}
    //                                 <Select
    //                                     className="react-select-container"
    //                                     classNamePrefix="react-select"
    //                                     options={specialtyOptions}
    //                                     menuPosition="fixed"
    //                                     styles={{
    //                                         menu: (base) => ({
    //                                             ...base,
    //                                             borderRadius: "15px",
    //                                             marginTop: "8px",
    //                                             backgroundColor: "#fff",
    //                                             padding: "6px",
    //                                             zIndex: "1000",
    //                                         }),
    //                                         menuPortal: (base) => ({
    //                                             ...base,
    //                                             zIndex: 9999,
    //                                         }),
    //                                         option: (base, state) => ({
    //                                             ...base,
    //                                             borderRadius: "8px",
    //                                             padding: "10px",
    //                                             backgroundColor: state.isFocused ? "#F3F9FC" : "#fff",
    //                                             color: "#091F28",
    //                                             cursor: "pointer",
    //                                             "&:active": {
    //                                                 backgroundColor: "#F3F9FC",
    //                                             },
    //                                         }),
    //                                     }}
    //                                     value={selectedSpecialty}
    //                                     onChange={(selectedOption) =>
    //                                         setSelectedSpecialty(selectedOption)
    //                                     }
    //                                     placeholder="Select Specialty"
    //                                 />
    //                             </Form.Group>
    //                         </Col>
    //                     </Row>

    //                     <Row>
    //                         <div className="form-section">
    //                             <label className="main-col-label">Cost of Living:</label>
    //                             <div className="radio-options">
    //                                 <div className="row">
    //                                     {renderOptions("costOfLiving", [
    //                                         "Low",
    //                                         "Medium",
    //                                         "Doesn't matter",
    //                                     ])}
    //                                 </div>
    //                             </div>
    //                         </div>

    //                         <div className="form-section">
    //                             <label className="main-col-label">Lifestyle:</label>
    //                             <div className="radio-options">
    //                                 <div className="row">
    //                                     {renderOptions("lifestyle", ["Urban", "Suburban", "Rural"])}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </Row>

    //                     <Row>
    //                         <div className="form-section housing">
    //                             <label className="main-col-label">Housing:</label>
    //                             <div className="radio-options">
    //                                 <div className="row">
    //                                     {renderOptions("housing", ["Rent", "Buy"])}
    //                                 </div>
    //                             </div>
    //                         </div>

    //                         <div className="form-section">
    //                             <label className="main-col-label">Hospital Type:</label>
    //                             <div className="radio-options">
    //                                 <div className="row">
    //                                     {renderOptions("hospitalType", [
    //                                         "Teaching",
    //                                         "Community",
    //                                         "Private",
    //                                     ])}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </Row>

    //                     <Row>
    //                         <div className="form-section">
    //                             <label className="main-col-label">Important Factors:</label>
    //                             <div className="checkbox-options">
    //                                 <div className="row">
    //                                     {renderOptions(
    //                                         "importantFactors",
    //                                         ["Schools", "Safety", "Salary"],
    //                                         true
    //                                     )}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </Row>

    //                     <div className="buttons text-center">
    //                         <Button className="btn btn-primary" onClick={handleSearch}>
    //                             Search
    //                         </Button>
    //                     </div>
    //                 </Card>
    //             </div>

    //             <div className="results">
    //                 <div className="app-page-title">
    //                     <div className="page-title-heading">
    //                         <h3 className="page-title">Result</h3>
    //                     </div>
    //                 </div>
    //                 {/* <h3>Result</h3> */}
    //                 <Row className="g-3">
    //                     {results.map((res, idx) => (
    //                         <Col md={6} xl={4} key={idx} className="result-card">
    //                             <Card className="contentwrap">
    //                                 <div className="city-name">{res.city}</div>

    //                                 <div className="meta">
    //                                     <span className="label">Avg RN Salary</span>
    //                                     <span className="value">{res.salary}</span>
    //                                 </div>

    //                                 <div className="meta">
    //                                     <span className="label">Cost of Living</span>
    //                                     <span className="value">{res.cost}</span>
    //                                 </div>

    //                                 <div className="meta">
    //                                     <span className="label">Top Hospitals</span>
    //                                     <div className="value">{res.hospital}</div>
    //                                 </div>

    //                                 <div className="meta">
    //                                     <span className="label">Schools</span>
    //                                     <div className="stars">
    //                                         {/* {res.schools === "Average" && "⭐⭐⭐⭐"}
    //                                         {res.schools === "Lower" && "⭐⭐⭐"}
    //                                         {res.schools === "Higher" && "⭐⭐⭐⭐⭐"} */}

    //                                         {res.schools === "Average" && <SchoolRating schoolLevel={res.schools} />}
    //                                         {res.schools === "Lower" && <SchoolRating schoolLevel={res.schools} />}
    //                                         {res.schools === "Higher" && <SchoolRating schoolLevel={res.schools} />}

    //                                     </div>
    //                                 </div>

    //                                 <div className="meta">
    //                                     <span className="label">Crime Rate</span>
    //                                     <span className="value">{res.crime}</span>
    //                                 </div>

    //                                 <div className="buttons d-flex justify-content-between">
    //                                     <Button className="btn btn-secondary">
    //                                         Compare
    //                                     </Button>
    //                                     <Button className="btn btn-primary">
    //                                         View Jobs
    //                                     </Button>
    //                                 </div>
    //                             </Card>
    //                         </Col>
    //                     ))}
    //                 </Row>
    //             </div>
    //         </Card.Body>
    //     </Card>

    //     {/* Chatbot component */}
    //     <Chatbot />
    // </div>
    <div className="relocation-content">
      <NoIndexSEO title={seoConfig.relocation.title} />
      <>
        <div className="comming-soon">
          <Card>
            <Card.Body>
              <h3 className="title text-center">Coming Soon!</h3>
              <div className="description text-center">
                This Page is under construction. Stay tuned for updates.
              </div>
              <div className="text-center mx-auto">
                <CommingSoonIcon />
              </div>
            </Card.Body>
          </Card>
        </div>
      </>
    </div>
  );
};

export default Relocation;
